var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters['isLocked'])?_c('v-row',{attrs:{"no-gutters":""}},[_c('version-expired'),_c('data-editor'),(_vm.CanRender)?_c('data-render'):_vm._e(),_c('toolbar')],1):_c('v-layout',{staticClass:"d-flex justify-center align-center flex-column pa-10",attrs:{"fill-height":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }